export const ANALYTICS_ACTIONS = {
  readersTab: 'readers_tab',
  documentViewsCta: 'document_views_cta',
  uniqueVisitorsCta: 'unique_visitors_cta',
  audienceReadersCta: 'audience_readers_cta',
  activityView: 'activity_view',
} as const;

export type AnalyticsAction =
  (typeof ANALYTICS_ACTIONS)[keyof typeof ANALYTICS_ACTIONS];
